import api from 'dao/providers/axios';
import appconfig from 'config/appconfig';
import environment from 'lib/environment';

const apiBaseUrl = { baseURL: environment.get().api.serviceUrl };
const tfaEndpoint = appconfig.endpoints.tfaMe;

export const daoTfaMeGet = () => api.get(tfaEndpoint, apiBaseUrl);
